import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '../components/Navbar';
import { formatCurrency } from '../utils/formatters';
import './CadastroProdutos.css';

const CadastroProdutos = () => {
    const [produtos, setProdutos] = useState([]);
    const [busca, setBusca] = useState('');
    const [criteria, setCriteria] = useState({
        NomeProduto: true,
        ID: false,
        PrecoUnitario: false
    });
    const [produtoAtual, setProdutoAtual] = useState(null);
    const [formData, setFormData] = useState({
        NomeProduto: '',
        PrecoUnitario: '',
        IDFornecedor: ''
    });
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);


    useEffect(() => {
        const fetchUser = async () => {
            const res = await fetch('/api/auth/me', { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setUser(data.user);
            }
        };
        const fetchSuppliers = async () => {
            try {
                const res = await fetch('/api/fornecedores', { credentials: 'include' });
                if (res.ok) {
                    const data = await res.json();
                    setSuppliers(data);
                }
            } catch (error) {
                console.error('Erro ao buscar fornecedores:', error);
            }
        };
        fetchUser();
        fetchSuppliers();
    }, []);

    const fetchProdutos = useCallback(async () => {
        setLoading(true);
        try {
            const selectedFields = Object.keys(criteria).filter(key => criteria[key]).join(',');
            let url = '/api/produtos';
            if (busca && selectedFields) {
                url += `?search=${encodeURIComponent(busca)}&fields=${encodeURIComponent(selectedFields)}`;
            }
            const response = await fetch(url, { credentials: 'include' });
            const data = await response.json();
            setProdutos(data);
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
        } finally {
            setLoading(false);
        }
    }, [busca, criteria]);

    useEffect(() => {
        fetchProdutos();
    }, [fetchProdutos]);

    const handleSearchChange = (e) => {
        setBusca(e.target.value);
    };

    const handleSearchSubmit = () => {
        fetchProdutos();
    };


    const selecionarProduto = (id) => {
        const p = produtos.find(item => item.ID === id);
        if (!p) return;
        setProdutoAtual(id);
        setFormData({
            NomeProduto: p.NomeProduto || '',
            PrecoUnitario: Number(p.PrecoUnitario || 0).toFixed(2),
            IDFornecedor: p.IDFornecedor || '',
            DataUltimaCotacao: p.DataUltimaCotacao || null
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (produtoAtual === null) return;
        try {
            const response = await fetch(`/api/produtos/${produtoAtual}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include'
            });
            if (response.ok) {
                alert('Produto atualizado com sucesso!');
                fetchProdutos(busca);
            } else {
                alert('Erro ao atualizar produto.');
            }
        } catch (error) {
            console.error('Erro ao salvar produto:', error);
        }
    };

    const criarNovoProduto = async () => {
        try {
            const response = await fetch('/api/produtos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    NomeProduto: 'Novo Produto',
                    PrecoUnitario: 0
                }),
                credentials: 'include'
            });
            const data = await response.json();
            if (response.ok) {
                alert('Novo produto criado com sucesso!');
                await fetchProdutos(busca);
                // Selecionar o novo produto (último ou pelo ID)
                // Como o fetchProdutos reordena por nome, melhor buscar pelo ID
                // Simplificando: recarrega e let user find it or implement selection logic
            } else {
                alert('Erro ao criar novo produto.');
            }
        } catch (error) {
            console.error('Erro ao criar produto:', error);
        }
    };

    return (
        <div className="cadastro-produtos-container">
            <Navbar user={user} />

            <div className="main-layout">
                <aside className="sidebar-produtos">
                    <div className="sidebar-header">
                        <h3>Produtos</h3>
                        <button className="btn-add-prod" onClick={criarNovoProduto}>+ Novo</button>
                    </div>

                    <div className="search-box">
                        <div className="search-input-group">
                            <input
                                type="text"
                                placeholder="Pesquisar..."
                                value={busca}
                                onChange={handleSearchChange}
                                onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit()}
                            />
                            <button className="btn-search-icon" onClick={handleSearchSubmit}>🔍</button>
                        </div>
                        <div className="criteria-group">
                            <label>
                                <input type="radio" name="prodSearchCriteria" checked={criteria.NomeProduto} onChange={() => setCriteria({ NomeProduto: true, ID: false, PrecoUnitario: false })} /> Nome
                            </label>
                            <label>
                                <input type="radio" name="prodSearchCriteria" checked={criteria.ID} onChange={() => setCriteria({ NomeProduto: false, ID: true, PrecoUnitario: false })} /> Código
                            </label>
                            <label>
                                <input type="radio" name="prodSearchCriteria" checked={criteria.PrecoUnitario} onChange={() => setCriteria({ NomeProduto: false, ID: false, PrecoUnitario: true })} /> Preço
                            </label>
                        </div>
                    </div>

                    <div className="produtos-list">
                        {loading ? (
                            <p>Carregando...</p>
                        ) : (
                            produtos.map((p) => (
                                <div
                                    key={p.ID}
                                    className={`produto-item ${produtoAtual === p.ID ? 'active' : ''}`}
                                    onClick={() => selecionarProduto(p.ID)}
                                >
                                    <span className="prod-code">#{p.ID}</span>
                                    <span className="prod-name">{p.NomeProduto}</span>
                                    <span className="prod-price">{formatCurrency(p.PrecoUnitario)}</span>
                                </div>
                            ))
                        )}
                    </div>
                </aside>

                <main className="content-produtos">
                    {produtoAtual !== null ? (
                        <div className="product-details-win">
                            <div className="win-header">
                                Detalhes do Produto #{produtoAtual}
                            </div>
                            <form onSubmit={handleSave} className="win-body">
                                <div className="form-group">
                                    <label>Nome do Produto</label>
                                    <input
                                        type="text"
                                        name="NomeProduto"
                                        value={formData.NomeProduto}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Preço Unitário (R$)</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        name="PrecoUnitario"
                                        value={formData.PrecoUnitario}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Fornecedor (Cotação)</label>
                                    <select
                                        name="IDFornecedor"
                                        value={formData.IDFornecedor}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">-- Selecionar Fornecedor --</option>
                                        {suppliers.map(s => (
                                            <option key={s.ID} value={s.ID}>
                                                {s.NomeEmpresa}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {formData.DataUltimaCotacao && (
                                    <div className="form-group">
                                        <label>Data da Última Cotação</label>
                                        <input
                                            type="text"
                                            readOnly
                                            value={new Date(formData.DataUltimaCotacao).toLocaleString('pt-BR')}
                                            style={{ backgroundColor: '#f0f0f0', cursor: 'default' }}
                                        />
                                    </div>
                                )}
                                <div className="form-actions">
                                    <button type="submit" className="btn-classic">Salvar Alterações</button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="no-selection">
                            <p>Selecione um produto na lista ao lado para editar.</p>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default CadastroProdutos;
